var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-search-com"},[(_vm.label)?_c('div',{staticClass:"vm-search-label",style:(_vm.labelStyle)},[(_vm.title)?_c('span',{attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.label))]):_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_c('div',{style:({width: _vm.valueWidth+'px'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }